const cardsOptions = [
	{
		name: {
			first: 'Тариф',
			second: 'IPnet 20 років'
		},
		note: {
			text: 'Акційна ціна діє протягом 20 місяців',
			textColor: '#db3867'
		},
		advantages: [
			{
				icon: require('../../assets/icons/speed.png'),
				text: '1000 Мбіт/c',
			},
			{
				icon: require('../../assets/icons/promo.png'),
				text: 'Акційне підключення'
			},
			{
				icon: require('../../assets/icons/support.png'),
				text: 'Технічна підтримка 24/7'
			}
		],
		cost: {
			unit: {
				currency: 'грн',
				month: 'міс'
			},
			promoCost: 200,
			fullCost: 20
		},
	},
	{
		name: {
			first: 'Роутер',
			second: 'TP-Link Archer C5 pro',
		},
		note: {
			text: 'Розстрочка на 5 місяців. <br>Вартість підключення та інсталяції 199 грн',
		},
		advantages: [
			{
				icon: require('../../assets/icons/speed_circle.png'),
				text: 'Висока швидкість',
			},
			{
				icon: require('../../assets/icons/signal.png'),
				text: 'Стабільний сигнал'
			},
			{
				icon: require('../../assets/icons/cover.png'),
				text: 'Збільшена зона покриття'
			}
		],
		cost: {
			unit: {
				currency: 'грн',
				month: 'міс'
			},
			promoCost: 1100,
			fullCost: 220
		}
	}
]

export default cardsOptions